export type AccountRole = "owner" | "member";
export type AccountScope = { kind: "tenant" } | { kind: "platform"; tenantPublicId: string };
export type TenantSummary = { public_id: string; name: string; slug: string; status: string; manager_count: number; member_count: number };
export type AccountUser = { public_id: string; email: string; role: string; is_active: boolean };
export type AccountInvitation = { public_id: string; email: string; role: string; status: string; expires_at: string };
export type IssuedInvitation = { public_id: string; link: string; expires_at: string };
export type AccessList = { users: AccountUser[]; invitations: AccountInvitation[] };
export type InvitationPreview = { tenant_name: string; email: string; role: string; account_exists: boolean; expires_at: string };
export const roleLabel = (role: string) => role === "owner" || role === "admin" ? "Responsable" : role === "member" ? "Membre" : role;
export const isManager = (role?: string) => role === "owner" || role === "admin";

export type ClosureView = {
  public_id: string; tenant_public_id: string; state: "closed" | "purging" | "purged";
  phase: string; version: number; error_code: string; closed_at: string;
  recovery_deadline_at: string; purge_started_at: string | null; purged_at: string | null; hold_review_at: string | null;
};
export type TenantDetail = AccessList & {tenant: TenantSummary; closure: ClosureView | null; lifecycle_enabled: boolean};
